/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-debugger */
/* eslint-disable sonarjs/no-identical-functions */
import { WithCoreProps, TranslationProps, ActionMetaService } from 'ff-shared-components-core';
import {
	ProcessFlowGotoOptions,
	processFlowGoto,
	processFlowBack,
	ProcessFlowStep,
	ProcessFlow,
} from '@shared/processFlow';
import './registerPharmacy.less';
import React from 'react';
import { connect } from 'react-redux';
import Flows from '..';
import { getResources } from '@i18n';
import {
	RegisterEntityData,
	ServiceChargeScreen,
	RegisterConclusionScreen,
	UserDataScreen,
	SubmitContractScreen,
} from '@screens';
import {
	StoreState,
	fetchPublicRegisterInitRequest,
	getHasAccessToken,
	fetchUpdateRegisterDataRequest,
	fetchSendForApprovalRequest,
	RegisterPharmacyState,
	RegisterInputData,
	SubscriptionTypes,
	StepRegisterInputData,
	resumeRegisterRequest,
	ResumeInputData,
	saveRegisterOnCancel,
} from '@store';
import { SubHeader, SubHeader2Appearance, SubHeader2 } from '@shared/components';
import { HostAppCommunicationBridgeHelper } from '@helpers';
import { RouteComponentProps } from 'react-router-dom';
import queryString from 'query-string';
import { EnrollmentTypes } from '@api/ff-shared-services-api';

interface RegisterPharmacyFlowInjectedProps extends TranslationProps {
	registerInputData: RegisterPharmacyState;
	hasAccessToken: boolean;
	back: () => void;
	goto: (goToStepName: string, goToFlowName?: string, options?: ProcessFlowGotoOptions) => void;
	fetchPublicRegisterInit: (metaData?: ActionMetaService) => void;
	fetchUpdateRegisterData: (registerData: StepRegisterInputData, successHandler?: () => void) => void;
	fetchSendForApproval: (metaData?: ActionMetaService) => void;
	fetchPublicRegisterResumeInit: (data: ResumeInputData, metaData?: ActionMetaService) => void;
	saveRegisterOnCancel: (metaData?: ActionMetaService) => void;
}

type Props = RegisterPharmacyFlowInjectedProps & RouteComponentProps;

interface RegisterPharmacyFlowState {
	typeOfConclusion: 'successSent' | 'successPending' | 'error' | 'warning' | 'saveOnCancelSuccess';
	initialStepName: string;
	allowedToRender: boolean;
}

class RegisterPharmacyFlow extends React.Component<Props, RegisterPharmacyFlowState> {
	public constructor(props: Props) {
		super(props);
		this.state = { typeOfConclusion: 'successSent', initialStepName: 'RegisterEntityData', allowedToRender: false };

		const {
			fetchPublicRegisterInit,
			hasAccessToken,
			fetchPublicRegisterResumeInit,
			history,
			match,
			location,
		} = this.props;

		debugger;

		const url = this.props.location.search;
		const params = queryString.parse(url);

		const resumeID = params.id;
		// const resumeID = '1328c008-0256-4124-b925-83e191d79d08';

		const data: ResumeInputData = {
			externalId: resumeID,
		};

		if (!hasAccessToken) {
			if (resumeID) {
				fetchPublicRegisterResumeInit(data, {
					successHandler: (res: any) => {
						debugger;
						if (res.hasError) {
							fetchPublicRegisterInit();
							this.setState({ initialStepName: 'RegisterEntityData', allowedToRender: true });
						} else if (res.request) {
							const auxStep = res.request.state ?? 'RegisterEntityData';
							const stepName =
								auxStep === 'DRAFT_PENDING_CONTRACT_SEND'
									? 'SubmitContractScreen'
									: 'RegisterEntityData';
							this.setState({ initialStepName: stepName, allowedToRender: true });
						}
					},
				});
			} else {
				fetchPublicRegisterInit({
					successHandler: (res: any) => {
						this.setState({ allowedToRender: true });
					},
				});
			}
		}
	}

	public render(): JSX.Element {
		const { allowedToRender } = this.state;
		return <>{allowedToRender ? this.renderFlow() : null}</>;
	}

	private renderFlow(): React.ReactNode {
		const { t, back, goto, fetchUpdateRegisterData, fetchSendForApproval, saveRegisterOnCancel } = this.props;

		const { typeOfConclusion, initialStepName } = this.state;

		const resources = getResources();

		const subHeaderWithFlowStepIndicator = (
			<SubHeader2
				appearance={SubHeader2Appearance.screenHeaderTitle}
				title={t('subHeader.titles.adherence')}
				subTitle={t('subHeader.subTitles.newAdherence')}
				hasStepsBar
				steps={[
					t<string>('stepper.adherenceSteps.step1'),
					t<string>('stepper.adherenceSteps.step2'),
					t<string>('stepper.adherenceSteps.step3'),
					t<string>('stepper.adherenceSteps.step4'),
					t<string>('stepper.steps.stepConclusion'),
				]}
				step={1}
			/>
		);

		return (
			<div className="register-flow-page">
				<ProcessFlow
					baseUrl={Flows.registerPharmacy.path}
					// initialStepName="RegisterEntityData"
					initialStepName={initialStepName}
					// initialStepName={this.getStepName()}
					resources={resources}
					subHeaderWithFlowStepIndicator={subHeaderWithFlowStepIndicator}
				>
					{/* Register Steps */}
					<ProcessFlowStep name="RegisterEntityData">
						<RegisterEntityData
							onClickNext={(data: StepRegisterInputData): void => {
								const subscription = data.registerInputData?.subscription;

								/* MOCK_DATA - START */
								// subscription = 'oneSubscription'; // data.subscription;
								/* MOCK_DATA - END */

								if (subscription === SubscriptionTypes.oneSubscription) {
									fetchUpdateRegisterData(data, () => {
										goto('ServiceChargeScreen');
										HostAppCommunicationBridgeHelper.scrollToTop();
									});
									return;
								} else {
									fetchUpdateRegisterData(data, () => {
										this.setState({ typeOfConclusion: 'successPending' });
										goto('RegisterConclusionScreen');
										HostAppCommunicationBridgeHelper.scrollToTop();
									});
									return;
								}
							}}
							onClickCancel={(): void => {
								this.setState({ typeOfConclusion: 'warning' });
								goto('RegisterConclusionScreen');
								HostAppCommunicationBridgeHelper.scrollToTop();
								return;
							}}
						/>
					</ProcessFlowStep>

					<ProcessFlowStep name="ServiceChargeScreen">
						<ServiceChargeScreen
							onClickNext={(data: StepRegisterInputData): void => {
								fetchUpdateRegisterData(data, () => {
									goto('UserDataScreen');
									HostAppCommunicationBridgeHelper.scrollToTop();
								});
								return;
							}}
							onClickBack={(): void => {
								// back();
								goto('RegisterEntityData');
								HostAppCommunicationBridgeHelper.scrollToTop();
								return;
							}}
							onClickCancel={(): void => {
								this.setState({ typeOfConclusion: 'warning' });
								goto('RegisterConclusionScreen');
								HostAppCommunicationBridgeHelper.scrollToTop();
								return;
							}}
						/>
					</ProcessFlowStep>

					<ProcessFlowStep name="UserDataScreen">
						<UserDataScreen
							fetchUpdateRegisterData={fetchUpdateRegisterData}
							onClickNext={(data: StepRegisterInputData): void => {
								fetchUpdateRegisterData(data, () => {
									goto('SubmitContractScreen');
									HostAppCommunicationBridgeHelper.scrollToTop();
								});
								return;
							}}
							onClickBack={(): void => {
								debugger;
								goto('ServiceChargeScreen');
								// back();
								HostAppCommunicationBridgeHelper.scrollToTop();
								return;
							}}
							onClickCancel={(): void => {
								this.setState({ typeOfConclusion: 'warning' });
								goto('RegisterConclusionScreen');
								HostAppCommunicationBridgeHelper.scrollToTop();
								return;
							}}
						/>
					</ProcessFlowStep>

					<ProcessFlowStep name="SubmitContractScreen">
						<SubmitContractScreen
							onClickNext={(data: RegisterInputData): void => {
								fetchSendForApproval({
									successHandler: (withSuccess: boolean) => {
										this.setState({ typeOfConclusion: withSuccess ? 'successSent' : 'error' });
										goto('RegisterConclusionScreen');
										HostAppCommunicationBridgeHelper.scrollToTop();
									},
								});
								return;
							}}
							onClickBack={(): void => {
								// back();
								goto('UserDataScreen');
								HostAppCommunicationBridgeHelper.scrollToTop();
								return;
							}}
							onClickCancel={(): void => {
								this.setState({ typeOfConclusion: 'warning' });
								goto('RegisterConclusionScreen');
								HostAppCommunicationBridgeHelper.scrollToTop();
								return;
							}}
						/>
					</ProcessFlowStep>

					<ProcessFlowStep name="RegisterConclusionScreen">
						<RegisterConclusionScreen
							alertType={typeOfConclusion}
							onClickNext={(data?: any): void => {
								saveRegisterOnCancel({
									successHandler: () => {
										this.setState({ typeOfConclusion: 'saveOnCancelSuccess' });
									},
								});
							}}
							onClickBack={(): void => {
								back();
								// goto('SubmitContractScreen');
								HostAppCommunicationBridgeHelper.scrollToTop();
								return;
							}}
							onClickExit={(): void => {
								// GO TO PUBLIC SITE DASHBOARD
								HostAppCommunicationBridgeHelper.goToHome();
								return;
							}}
						/>
					</ProcessFlowStep>
				</ProcessFlow>
			</div>
		);
	}
}

const mapStateToProps = (state: StoreState): object => ({
	hasAccessToken: getHasAccessToken(state),
});

const mapDispatchToProps = (dispatch: any): object => ({
	fetchPublicRegisterInit: (metaData?: ActionMetaService): void => dispatch(fetchPublicRegisterInitRequest(metaData)),
	fetchUpdateRegisterData: (registerData: StepRegisterInputData, successHandler?: () => void): void =>
		dispatch(fetchUpdateRegisterDataRequest(registerData, successHandler && { successHandler })),
	fetchPublicRegisterResumeInit: (data: ResumeInputData, metaData?: ActionMetaService): void =>
		dispatch(resumeRegisterRequest(data, metaData)),
	saveRegisterOnCancel: (metaData?: ActionMetaService): void => dispatch(saveRegisterOnCancel(metaData)),
	fetchSendForApproval: (metaData?: ActionMetaService): void => dispatch(fetchSendForApprovalRequest(metaData)),
	goto: (goToStepName: string, goToFlowName?: string, options?: ProcessFlowGotoOptions): void =>
		dispatch(processFlowGoto(goToStepName, goToFlowName, options)),
	back: (): void => dispatch(processFlowBack()),
});

export default WithCoreProps(connect(mapStateToProps, mapDispatchToProps)(RegisterPharmacyFlow));
